import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Wrapper = styled.button`
    width: 30px;
    height: 30px;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 6px;
    border: none;
    cursor: pointer;

    transition:
        background-color 200ms ease,
        color 200ms ease;
    color: rgba(255, 255, 255, 0.5);

    display: flex;
    align-items: center;
    justify-content: center;

    position: relative;

    &:hover {
        color: #fff;
        background-color: rgba(255, 255, 255, 0.15);
    }
`;

export const Toast = styled(motion.div)`
    position: absolute;
    bottom: 100%;
    right: 0;
    z-index: 10;

    pointer-events: none;

    background: #17b61d;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
    border-radius: 6px;

    height: 28px;
    display: flex;
    align-items: center;

    color: #fff;
    font-weight: 700;
    font-size: 12px;
    line-height: 150%;

    padding: 0 10px;
    margin-bottom: 7px;
`;
